import Vue from 'vue';
import Cookie from 'js-cookie';
import $ from 'jquery';
import template from './template.html';

window.cook = Cookie;

export default Vue.component('audio-player', {
  template: template,
  data () {
    return {
      audio: null,
      btnAnim: null,
      playing: false,
      pauseIcon: 'M11,10 L18,13.74 18,22.28 11,26 M18,13.74 L26,18 26,18 18,22.28',
      playIcon: 'M11,10 L17,10 17,26 11,26 M20,10 L26,10 26,26 20,26'
    };
  },
  mounted () {
    let $vm = this;
    let $el = $(this.$el);
    let audio = $el.find('audio')[0];
    let btnAnim = $el.find('animate')[0];

    let cookiePlaying = Cookie.get('playing');

    audio.addEventListener('loadedmetadata', function () {
      $vm.audio = audio;
      $vm.btnAnim = btnAnim;

      audio.currentTime = 8;
      audio.volume = 0.5;

      audio.addEventListener('play', function () {
        $vm.playing = true;
      });

      audio.addEventListener('pause', function () {
        $vm.playing = false;
      });

      if(cookiePlaying == '1' || cookiePlaying === undefined) {
        $vm.togglePlay();
      }
    });

  },
  methods: {
    togglePlay () {
      if(this.playing) {
        this.audio.pause();
        Cookie.set('playing',0);
      } else {
        this.audio.play();
        Cookie.set('playing',1);
      }
    }
  }
});



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/components/audio-player/main.js